/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropaspectstory2Inputs */

const en_cropaspectstory2 = /** @type {(inputs: Cropaspectstory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9:16`)
};

const de_cropaspectstory2 = /** @type {(inputs: Cropaspectstory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9:16`)
};

/**
* | output |
* | --- |
* | "9:16" |
*
* @param {Cropaspectstory2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropaspectstory2 = /** @type {((inputs?: Cropaspectstory2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropaspectstory2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropaspectstory2(inputs)
	return de_cropaspectstory2(inputs)
});
export { cropaspectstory2 as "cropAspectStory" }